import { render, staticRenderFns } from "./DeleteSimCards.vue?vue&type=template&id=acb1418a&"
import script from "./DeleteSimCards.vue?vue&type=script&lang=js&"
export * from "./DeleteSimCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports